<template>
    <div>
        <template
            v-if="cerfa_ && cerfa_.values && cerfa_.values.length && isLoaded && fieldsChildLoaded"
        >
            <svg viewBox="0 0 1240 1754" :style="svgFormStyle">
                <g v-for="(value, vi) of cerfa_.values" :key="vi">
                    <foreignObject
                        :x="getX(value)"
                        :y="getY(value)"
                        :width="getWidth(value)"
                        :height="getHeight(value)"
                    >
                        <div style="color: red" v-if="!fieldsChild_ || !fieldsChild_[value.key]">
                            {{ value.key }}
                        </div>

                        <v-checkbox
                            v-else-if="
                                value.key === 'NEANT' ||
                                (selectorOfKey(value.key) && isCheckbox(selectorOfKey(value.key)))
                            "
                            v-model="fieldsChild_[value.key].displayValue"
                            :readonly="value.key === 'NEANT' || isReadonly(value.key)"
                            true-value="X"
                            false-value
                            hide-details
                            class="ma-0 pa-0 custom-checkbox-taxform-png"
                            :ripple="false"
                            @click="updateSpecManager()"
                        />
                        <v-select-filled
                            v-else-if="selectorOfKey(value.key)"
                            v-model="fieldsChild_[value.key].displayValue"
                            :readonly="isReadonly(value.key)"
                            hide-details
                            :items="getSelectorValuesFile(selectorOfKey(value.key))"
                            class="text-field-for-tax-form"
                            @update:model-value="updateSpecManager()"
                            item-title="text"
                            item-value="value"
                        />
                        <input
                            v-else
                            v-model="fieldsChild_[value.key].displayValue"
                            hide-details
                            :readonly="isReadonly(value.key)"
                            :class="
                                justifyInputRight(value.key)
                                    ? 'oss-text-field-for-tax-form oss-text-field-justify-end'
                                    : 'oss-text-field-for-tax-form'
                            "
                            @update:model-value="updateSpecManager()"
                        />
                    </foreignObject>
                </g>
            </svg>
        </template>
    </div>
</template>
<script lang="ts">
import { TaxFormBase } from "./TaxFormBase";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component
export class TaxFormPng extends TaxFormBase {
    @Prop({ default: null }) cerfa: any;
    @Prop({ default: null }) image: any;

    zoom = 1;

    get svgFormStyle() {
        return {
            width: "-webkit-fill-available",
            height: "auto",
            "background-image": `url('${this.imageUrl_}')`,
            "background-size": "contain",
            transform: `scale(${this.zoom})`,
        };
    }

    get fieldsChildLoaded() {
        return this.fieldsChild_ && Object.keys(this.fieldsChild_).length;
    }

    get cerfa_() {
        if (this.sheet) {
            return this.sheet.cerfa;
        }
        return this.cerfa;
    }

    get imageUrl_() {
        if (this.sheet) {
            return this.sheet.imageUrl;
        }
        return this.image;
    }

    resetZoom() {
        this.zoom = 1;
    }

    zoomOut() {
        this.zoom -= 0.1;
    }

    zoomIn() {
        this.zoom += 0.1;
    }

    getX(value) {
        return value.boundingBox.left * this.zoom;
    }

    getY(value) {
        return value.boundingBox.top * this.zoom;
    }

    getWidth(value) {
        return value.boundingBox.width * this.zoom;
    }

    getHeight(value) {
        return value.boundingBox.height * this.zoom;
    }

    mounted() {
        const elements = document.querySelectorAll(
            ".custom-checkbox-taxform-png .v-selection-control--density-default",
        );
        elements.forEach((element) => {
            if (element instanceof HTMLElement) {
                element.style.setProperty("left", "-0.5vw");
                element.style.setProperty("top", "-2vh");
            }
        });
    }
}

export default toNative(TaxFormPng);
</script>

<style lang="scss" scoped>
.document-display {
    background-color: #fff;
    width: calc(100vw - 16px);
}

.oss-text-field-for-tax-form {
    background: #eaeaea;
    width: 100%;
    height: 100%;
    &:focus {
        outline: none;
        border-bottom: 1px solid #f9b12a;
    }
}

.oss-text-field-justify-end {
    text-align: right;
}
</style>
